module.exports = __webpack_public_path__ + "static/img/icon_fabu@2x.ac703011.png";